import styled from 'styled-components'

import { helpers } from '../../../styles/theme'

type Props = {
	isSmall?: boolean
}

export const Label = styled.label<Props>`
	color: ${helpers.color.input.label};
	display: flex;
	flex-direction: column;
	font-size: ${({ isSmall = false }) => (isSmall ? '12px' : '15px')};
	line-height: ${({ isSmall = false }) => (isSmall ? '1' : 'unset')};
	margin-bottom: 3px;
	width: fit-content;
`
